/* unplugin-vue-components disabled */import script from "./HowToPlayTour.vue?vue&type=script&setup=true&lang=js"
export * from "./HowToPlayTour.vue?vue&type=script&setup=true&lang=js"

import "./HowToPlayTour.vue?vue&type=style&index=0&id=188688fe&lang=scss&scoped=true"
import "./HowToPlayTour.vue?vue&type=style&index=1&id=188688fe&lang=scss"

import exportComponent from "../../../../../../Users/mac/myproject/deepsage/deepsage_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-188688fe"]])

export default __exports__